import React, { Component, Fragment } from "react";
import { Row, Card,CardHeader, CardTitle, Button, CardBody, FormGroup, Input, DropdownItem, CustomInput, Badge, DropdownMenu } from "reactstrap";
import IntlMessages from "../../../helpers/IntlMessages";
import { Colxx, Separator } from "../../../components/common/CustomBootstrap";
import Breadcrumb from "../../../containers/navs/Breadcrumb";
import { NavLink } from "react-router-dom";
import DataTablePagination from "../../../components/DatatablePagination";
import ItemDropdown from "../../../components/customer/ItemDropdown";

import ReactTable from "react-table";

import swal from 'sweetalert';
import {REST_API_END_POINT,dataEncryptKey,JQUERY_MODULE} from "../../../constants/defaultValues";
import axios from 'axios';
import SimpleCrypto from "simple-crypto-js";
import moment from "moment";
import { zeroPad } from "../../../helpers/Utils";

import InvoiceModal from "../../../containers/inventory-transfer/InvoiceModal";
import PrintShippingManifestModal from "../../../containers/inventory-transfer/PrintShippingManifestModal";
import SignshippingModal from "../../../containers/inventory-transfer/SignshippingModal";
import ProcessOrderModal from "../../../containers/inventory-transfer/ProcessOrderModal";

var dataCrypto = new SimpleCrypto(dataEncryptKey);

export default class AllIncomingTransfer extends Component {
	
	constructor(props) {
		super(props);
		this.dataListRender = this.dataListRender.bind(this);
		this.toggleModalInvoice = this.toggleModalInvoice.bind(this);
		this.toggleModalSignManifest = this.toggleModalSignManifest.bind(this);
		this.toggleModalPrintShippingManifest = this.toggleModalPrintShippingManifest.bind(this);
		this.toggleModalProcess = this.toggleModalProcess.bind(this);
		
		this.state = {
		 	modalOpenInvoice:false,
			modalOpenSignManifest:false,
			modalOpenPrintShippingManifest:false,
			modalOpenProcess: false,			
			search: '',
			inventory_transfers:[],
			order_id:0
		};
	}
	
	dataListRender() {
		var facility_id = localStorage.getItem('facility_id');
		facility_id =  dataCrypto.decrypt(facility_id);
        var formData = new FormData();
        formData.append('facility_id',facility_id);
		
		axios.post(REST_API_END_POINT+'inventory-transfer/get-all-incoming-inventory-transfers',formData).then((res)=>{
			var data = res.data;
		
			if(data.inventory_transfers){
				this.setState({
					inventory_transfers: data.inventory_transfers,
					selectAll:0,
					selectedIds:[]
				});
			}else{
				this.setState({
					inventory_transfers: [],
					selectAll:0,
					selectedIds:[]
				});
			}
        }).catch(e =>{
			console.log("Addition failed , Error ", e);
		});
	}
	
	componentDidMount(){
	   this.dataListRender();
	}
	
	toggleModalInvoice = (e,order_id =0) => {
		this.setState({
		  order_id: parseInt(order_id),
		  modalOpenInvoice: !this.state.modalOpenInvoice
		});
	};
	
	toggleModalSignManifest = (e,order_id =0) => {
		this.setState({
		  order_id: parseInt(order_id),
		  modalOpenSignManifest: !this.state.modalOpenSignManifest
		});
	};
	
	toggleModalPrintShippingManifest = (e,order_id =0) => {
		this.setState({
		  order_id: parseInt(order_id),
		  modalOpenPrintShippingManifest: !this.state.modalOpenPrintShippingManifest
		});
	};
	
	toggleModalProcess = (e,order_id =0) => {
		this.setState({
		  order_id: parseInt(order_id),
		  modalOpenProcess: !this.state.modalOpenProcess
		});
	};

 
  render() {
		let data = this.state.inventory_transfers;
		if (this.state.search) {
			data = data.filter(row => {
				return row.facility_name.toLowerCase().includes(this.state.search.toLowerCase()) || row.payment_mode.toLowerCase().includes(this.state.search.toLowerCase()) || row.order_number.includes(this.state.search)
			})
		}
		
		const dataTableColumns = [
			{
				Header: "Order ID",
				accessor: "order_number",
				Cell: props => <p className="list-item-heading mb-0">{zeroPad(props.value,6)}</p>
			},
			{
				Header: "Facility Name",
				accessor: "facility_name",
				Cell: props => <p className="list-item-heading">{props.value}</p>
			},
			{
				Header: "Order Date",
				accessor: "timestamp",
				Cell: props => <p className="list-item-heading">{moment(props.value*1000).format('MM/DD/YYYY')}</p>
			},
			{
				Header: "Payment Mode",
				accessor: "payment_mode",
				Cell: props => <p className="list-item-heading">{props.value}</p>
			},
			{
				Header: "Payment Status",
				accessor: "payment_status",
				Cell: props => <p className="list-item-heading">{props.value==1 ? 'Paid':'Unpaid'}</p>
			},
			{
				Header: "Status",
				accessor: "status",
				Cell: props => {			
					if(props.value==0){
						return(<Badge color="warning" pill>Waiting for Approval</Badge>);
					}else if(props.value==1){
						return(<Badge color="primary" pill>Approved</Badge>);
					} else if(props.value==2){
						return(<Badge color="primary" pill>Processed</Badge>);
					} else if(props.value==3){
						return(<Badge color="success" pill>Completed</Badge>);
					} else {
						return(<Badge color="danger" pill>Canceled</Badge>);
					}
				}
			},	  	  
			{
				Header: "Actions",
				accessor: "order_id",
				Cell: props => <Fragment>
					<div className="action-btns p-0">
						<ItemDropdown item={<DropdownMenu >
							<DropdownItem className="cursor-pointer" onClick={(e)=>{ this.toggleModalInvoice(e,props.value) }} >
								<span className="d-inline-block">Invoice</span>
							</DropdownItem>
							{props.original.signature==null ? <DropdownItem className="cursor-pointer" onClick={(e)=>{ this.toggleModalSignManifest(e,props.value) }} >
								<span className="d-inline-block" >Sign Shipping Manifest</span>
							</DropdownItem>:""}
							{/* <DropdownItem className="cursor-pointer" onClick={(e)=>{ this.toggleModalPrintShippingManifest(e,props.value) }} >
								<span className="d-inline-block">Print Shipping Manifest</span>
							</DropdownItem> */}
							{props.original.status==1 ? <DropdownItem className="cursor-pointer" onClick={(e)=>{ this.toggleModalProcess(e,props.value) }} >
								<span className="d-inline-block" >Process Order</span>
							</DropdownItem>:""}
						</DropdownMenu>} />
					</div>
				</Fragment>
			}
		];
		
    return (
      <Fragment>
        <Row>
          <Colxx xxs="12">
            <Breadcrumb heading="menu.incoming-transfer" match={this.props.match} />
            <Separator className="mb-5" />
          </Colxx>
        </Row>	
		<Card className="p-4">
		   <Row>
				<Colxx xxs="12">
					<div id="api_message"></div>
				</Colxx> 
			  <Colxx xxs="12">					
					<div className="mb-4 dropdown-edit">						
						<FormGroup row>
							<Colxx lg="6">
								<Input
								  type="text"
								  name="table_search"
								  id="table_search"
								  placeholder="Search"
								  value={this.state.search}
								  onChange={e => this.setState({search: e.target.value})}
								/>
							</Colxx>
						</FormGroup>			
						<ReactTable
						  data={data}
						  columns={dataTableColumns}
						  defaultPageSize={10}
						  filterable={false}
						  showPageJump={false}
						  PaginationComponent={DataTablePagination}
						  showPageSizeOptions={true}
						  defaultSorted={[{id: "send_on",desc: false}]}
						/>
					</div>
					
					<InvoiceModal
						modalOpen={this.state.modalOpenInvoice}
						toggleModal={this.toggleModalInvoice}
						order_id={this.state.order_id}
					/>
					
					<PrintShippingManifestModal
						modalOpen={this.state.modalOpenPrintShippingManifest}
						toggleModal={this.toggleModalPrintShippingManifest}
						order_id={this.state.order_id}
					/>
				
					<SignshippingModal
						modalOpen={this.state.modalOpenSignManifest}
						toggleModal={this.toggleModalSignManifest}
						dataListRender={this.dataListRender}
						order_id={this.state.order_id}
					/>
					
					<ProcessOrderModal
						modalOpen={this.state.modalOpenProcess}
						toggleModal={this.toggleModalProcess}
						dataListRender={this.dataListRender}
						order_id={this.state.order_id}
					/>
			  </Colxx>
			</Row>
		</Card>
      </Fragment>
    );
  }
}
